const serviceData = [
    {
        id: 1,
        title: 'Unique Selection',
        text: 'We only sell uniquely selected plants which we assure will grow well with correct care.',
        icon: 'plant-on-a-hand',
    },
    {
        id: 2,
        title: 'Plant Delivery',
        text: 'We offer a professional plant delivery services to any place where a plant can grow easily without much effort.',
        icon: 'truck',
    },
    {
        id: 3,
        title: 'Plant Curation',
        text: "Your lovely plant is dying? Don't worry. We can have it green again if you notice irregular symptoms early and bring it to us in time.",
        icon: 'leaf',
    },
    {
        id: 4,
        title: 'Customer Support',
        text: 'We carefully stock only indoor plants of high quality and standard. We are also here for any consultation concerned with your plants.',
        icon: 'comments',
    },
];

export default serviceData;
